export const PARTNER_CODES = {
  SABER15:  { discount: 0.15, name: "Saber" },
  ASLAM15:  { discount: 0.15, name: "Aslam" },
  TAYYAB15: { discount: 0.15, name: "Tayyab" },
};

export function validatePartnerCode(code) {
  return PARTNER_CODES[code?.toUpperCase?.().trim()] ? code.toUpperCase().trim() : null;
}

export function getPartnerDiscount(code, amount) {
  const entry = PARTNER_CODES[code];
  return entry ? Math.round(amount * entry.discount) : 0;
}
